import { v4 as uuidv4 } from "uuid";

const UUID_STORAGE_KEY = "botblogr_session_uuid";

/**
 * Generates a timestamp-based UUID and stores it in localStorage
 * @returns {string} The generated UUID
 */
export const generateSessionUUID = () => {
    const timestamp = Date.now();
    const uuid = `${timestamp}_${uuidv4()}`;
    localStorage.setItem(UUID_STORAGE_KEY, uuid);
    return uuid;
};

/**
 * Gets the existing UUID from localStorage or generates a new one
 * @returns {string} The session UUID
 */
export const getSessionUUID = () => {
    let uuid = localStorage.getItem(UUID_STORAGE_KEY);

    if (!uuid) {
        uuid = generateSessionUUID();
        console.log("🆔 Generated new UUID:", uuid);
    } else {
        console.log("🆔 Using existing UUID:", uuid);
    }

    return uuid;
};

/**
 * Clears the stored UUID (useful for logout or page refresh)
 */
export const clearSessionUUID = () => {
    localStorage.removeItem(UUID_STORAGE_KEY);
};

/**
 * Regenerates UUID on page refresh/reload
 * This should be called when the app initializes
 */
export const handlePageRefresh = () => {
    // Always generate new UUID on page refresh
    return generateSessionUUID();
};